import { featureFlags } from '@shared-services/feature-flags';

const isCustomizationsWidgetInDOM = () =>
    typeof document !== 'undefined' &&
    !!document.querySelector('[data-auto="product-customizations"]');

export const isProductCustomizationsEnabled = () =>
    featureFlags.getBoolean('runtime.ssr.productCustomizations') &&
    isCustomizationsWidgetInDOM();
